import {userConstants} from '../../_constants';

export function listDeliveryServices(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_LIST_DELIVERY_SERVICES_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_LIST_DELIVERY_SERVICES_SUCCESS:
      return {
        loading: false,
        // typeDelivery: action.data,
        ...action.data,
      };
    case userConstants.GET_LIST_DELIVERY_SERVICES_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
